/**
* @author Camilo
* @since  08/11/2017
**/
import { Injectable } from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import { InfoSesion } from './../Global/InfoSesion.model';
import { NavigationModel } from '../../../navigation.model';
import { Navegacion } from './Navegacion.model';



@Injectable()
export class AuthService {

	clearSession(serviciosGenerales){
		serviciosGenerales.post('guardar/cierreSesion', {
			usuario  : this.getInfoSesion().usuario,
			empresa  : JSON.parse(this.getInfoToken().empresa).empresa,
			idsesion : sessionStorage.getItem('idsesion')
		}).subscribe(x=>{});
		sessionStorage.removeItem('info');
		sessionStorage.removeItem('idsesion');
	}

	getInfoSesion():InfoSesion{
		let infoSesion:InfoSesion = JSON.parse(sessionStorage.getItem('info'));
		if(infoSesion == null || infoSesion == undefined)
			return new InfoSesion(new NavigationModel(), "", [], "");
		return JSON.parse(sessionStorage.getItem('info'));
	}

	getToken(): string {
		let infoSesion:InfoSesion = JSON.parse(sessionStorage.getItem('info'));
		if(infoSesion == null || infoSesion == undefined)
			return "";
		return infoSesion.token;
	}

	isEliminar(){
		return JSON.parse(this.getInfoToken()[this.getInfoSesion().formularioActivo]).d;
	}
	isAgregar(){
		return JSON.parse(this.getInfoToken()[this.getInfoSesion().formularioActivo]).c;
	}
	isEditar(){
		return JSON.parse(this.getInfoToken()[this.getInfoSesion().formularioActivo]).u;
	}
	isConsultar(){
		return JSON.parse(this.getInfoToken()[this.getInfoSesion().formularioActivo]).r;
	}
	getCrud():any{
		return JSON.parse(this.getInfoToken()[this.getInfoSesion().formularioActivo]);
	}

	setInfoSesion(infoSesion:InfoSesion){
		sessionStorage.setItem('info', JSON.stringify(infoSesion));
	}

	setActivo(activo:string){
		let infoSesion:InfoSesion = this.getInfoSesion();
		infoSesion.formularioActivo = activo;
		this.setInfoSesion(infoSesion);
	}

	setToken(token: string): void {
		let infoSesion:InfoSesion = this.getInfoSesion();
		infoSesion.token = token;
		this.setInfoSesion(infoSesion);
	}

	public isAuthenticated(): boolean {

		let token = this.getToken();
		if(token == undefined || token == null || token == ''){
			
			return false;	
		} 

		const date = this.getTokenExpirationDate();
		

		if(date === undefined) {
			
			return false;
		}
		
		return (date.valueOf()-(5*60*1000) > new Date().valueOf());

	}

	getTokenExpirationDate(): Date {
		let token = this.getToken();
		const decoded = jwt_decode(token);
		if (decoded.exp === undefined) return null;

		const date = new Date(0); 
		date.setUTCSeconds(decoded.exp);

		return date;
	}

	isTokenExpired(): boolean {
		let token = this.getToken();
		if(token == undefined || token == null || token == '') return true;

		const date = this.getTokenExpirationDate();
		if(date === undefined) return false;
		return !(date.valueOf() > new Date().valueOf());
	}

	getInfoToken(){
		return jwt_decode(this.getToken());
	}

	agregarNavegacion(rutaAnterior_p:string, parametros_p:Array<string>){
		
		let navegacion = sessionStorage.getItem('navegacion');
		if(navegacion == null || navegacion == ''){
			sessionStorage.setItem('navegacion', JSON.stringify([{rutaAnterior : rutaAnterior_p, parametros : parametros_p}]));
		}else{
			let navegacionTemp = JSON.parse(navegacion);
			navegacionTemp.push({rutaAnterior : rutaAnterior_p, parametros : parametros_p});
			sessionStorage.setItem('navegacion', JSON.stringify(navegacionTemp));
		}

	}

	getUltimaNavegacion() : any{
		let navegacion = JSON.parse(sessionStorage.getItem('navegacion'));
		return navegacion[navegacion.length - 1];
	}

	quitarUltimaNavegacion(){
		let navegacion = JSON.parse(sessionStorage.getItem('navegacion'));
		navegacion.splice( (navegacion.length - 1), 1);
		sessionStorage.setItem('navegacion', JSON.stringify(navegacion));
	}

	



}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Seguridad/auth.service.ts